module.exports = "/img/_/_/_/assets/images/creeper/book/uncommon//26.jpg?9563b849f1159a00bcc83a466168da4e";